import Marionette from "backbone.marionette";

import CSS from "views/pagination/pagination.css";
import paginationTpl from "views/pagination/pagination.ejs";

import S from "session/session.js";

export default Marionette.View.extend({
    initialize: function(data) {
        this.attributes = data.attributes;
    },
    template: paginationTpl,
    render: function() {
        this.$el.html(this.template({
            total_items: this.attributes.total_items,
            page: this.attributes.page,
            page_count: this.attributes.page_count,
            page_size: this.attributes.page_size,
            lang: S.userInfo.attributes.lang
        }));
    },
    events: {
        "click #next:not(.active)": "next",
        "click #prev:not(.active)": "prev",
        "click .page:not(.active)": "page"
    },
    next: function(ev) {
        ev.preventDefault();
        S.mApp.trigger("next", {
            target: ev.target
        });
    },
    prev: function(ev) {
        ev.preventDefault();
        S.mApp.trigger("prev", {
            target: ev.target
        });
    },
    page: function(ev) {
        ev.preventDefault();
        S.mApp.trigger("page", {
            target: ev.target
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/pagination/pagination.js
// module id = 11
// module chunks = 0